var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sharing__buttons" },
    [
      _vm._t("before"),
      _vm.intro
        ? _c(
            "div",
            { staticClass: "sharing__intro", class: _vm.addClasses.intro },
            [
              _vm._t(
                "intro",
                [_c("span", { domProps: { innerHTML: _vm._s(_vm.intro) } })],
                { intro: _vm.intro }
              )
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "buttons__buttons" },
        _vm._l(_vm.socials_arr, function(social) {
          return _c(
            "button",
            {
              staticClass: "sharing__button buttons__button",
              class: [social, _vm.addClasses.button],
              on: {
                click: function($event) {
                  return _vm.share(social)
                }
              }
            },
            [
              _vm._t("button", [_c("span", { class: "icon-" + social })], {
                social: social
              })
            ],
            2
          )
        }),
        0
      ),
      _vm._t("after")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }